import {registerTileSchema} from '#core/application/schema-registry.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';
import EVENT_CARD_DETAILS from '#core/application/modules/cards-and-promotions/classic-cards/event-cards/event-card-details.palette-schema.yaml';

import {AvantgardeCards} from '../avantgarde-cards.js';

import {avantgardeEventCardsFactory} from './avantgarde-event-cards.factory.js';

import PALETTE_SCHEMA from './avantgarde-event-cards.palette-schema.yaml';

registerTileSchema(EVENT_CARD_DETAILS);

class AvantgardeEventCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'AvantgardeEventCards';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return avantgardeEventCardsFactory(PALETTE);
    }
}

new AvantgardeEventCardsFeature(AvantgardeCards);
